@@ -0,0 +1,42 @@
<template>
  <v-card color="primary" class="rounded-sm">
    <v-card-text>
      <v-container v-if="documento && documento.observaciones">
        <v-row>
          <v-col cols="12">
            <div class="text-caption mb-1">Observaciones</div>
            <div v-for="(linea, index) in observacionesLineas" :key="index" class="text-body-1 text--primary">
              {{ linea }}
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else>
        <div class="text-body-2 text--secondary">No hay observaciones disponibles.</div>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    documento: {
      type: Object,
      default: null,
    },
  },
  computed: {
    observacionesLineas() {
      if (!this.documento?.observaciones) return []
      return this.documento.observaciones.split(/\r\n|\n/)
    },
  },
}
</script>
